module.exports = __webpack_public_path__ + "static/WWCTampa-8d4d46b7514be552c1174e74bbf1b73a.jpg";